import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilestackModule } from '@filestack/angular';

import { ContactsRoutingModule } from './contacts-routing.module';
import { SharedModule } from '../shared/shared.module';
import { UserGroupsListingComponent } from './user-groups-listing/user-groups-listing.component';
import { ContactsListingComponent } from './contacts-listing/contacts-listing.component';
import { CreateContactComponent } from './create-contact/create-contact.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploadContactComponent } from './upload-contact/upload-contact.component';
import { ProcessUploadComponent } from './process-upload/process-upload.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ManagerGroupSelectorComponent } from './contacts-listing/manager-group-selector/manager-group-selector.component';
import { SendToCampaignComponent } from './send-to-campaign/send-to-campaign.component';
import { MoveContactsComponent } from './move-contacts/move-contacts.component';
import { BatchMoveDialogComponent } from './move-contacts/batch-move-dialog/batch-move-dialog.component';
import { UploadDialogComponent } from './move-contacts/upload-dialog/upload-dialog.component';
import { UploadConfirmationDialogComponent } from './move-contacts/upload-confirmation-dialog/upload-confirmation-dialog.component';
import { EmailPositionComponent } from './contacts-listing/email-position/email-position.component';
import { TotalActiveColumnComponent } from './user-groups-listing/total-active-column/total-active-column.component';

@NgModule({
  declarations: [
    UserGroupsListingComponent,
    ContactsListingComponent,
    CreateContactComponent,
    UploadContactComponent,
    ProcessUploadComponent,
    ManagerGroupSelectorComponent,
    SendToCampaignComponent,
    MoveContactsComponent,
    BatchMoveDialogComponent,
    UploadDialogComponent,
    UploadConfirmationDialogComponent,
    EmailPositionComponent,
    TotalActiveColumnComponent,
  ],
  imports: [
    CommonModule,
    ContactsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    FilestackModule,
    FontAwesomeModule,
  ],
})
export class ContactsModule {}
